import { FaqsPropertyList } from '@/components/Faqs/property';

const DataBasePropertyPage = () => {
  return <FaqsPropertyList />;
};

export default DataBasePropertyPage;
